export const ITR_updateMonthlyStatementErrReducer = {
  ITR_updateMonthlyStatementErr: (state, action) => {
    state.monthlyStatementErr = action.payload;
  },
};
